var _g, _path, _path2, _rect, _g2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedalSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 122,
    viewBox: "0 0 123 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_23305_180428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8717 14.5159L19.9556 31.376C16.2678 33.5262 14 37.4737 14 41.7426V75.2574C14 79.5263 16.2678 83.4738 19.9556 85.624L48.8717 102.484C52.5993 104.658 57.2068 104.662 60.9389 102.497L90.0228 85.6199C93.7228 83.4729 96 79.5186 96 75.2408V41.7592C96 37.4814 93.7228 33.5271 90.0228 31.3801L60.9389 14.5033C57.2068 12.3376 52.5993 12.3424 48.8717 14.5159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8717 14.5159L19.9556 31.376C16.2678 33.5262 14 37.4737 14 41.7426V75.2574C14 79.5263 16.2678 83.4738 19.9556 85.624L48.8717 102.484C52.5993 104.658 57.2068 104.662 60.9389 102.497L90.0228 85.6199C93.7228 83.4729 96 79.5186 96 75.2408V41.7592C96 37.4814 93.7228 33.5271 90.0228 31.3801L60.9389 14.5033C57.2068 12.3376 52.5993 12.3424 48.8717 14.5159Z",
    stroke: "#ECE9F8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5337 20.0146L25.3894 34.1958C21.7203 36.3508 19.4668 40.2878 19.4668 44.543V72.8966C19.4668 77.1518 21.7203 81.0888 25.3894 83.2438L49.5337 97.425C53.2779 99.6242 57.9181 99.629 61.6669 97.4377L85.9559 83.2399C89.6372 81.088 91.9001 77.1441 91.9001 72.8799V44.5597C91.9001 40.2955 89.6372 36.3517 85.9559 34.1998L61.6669 20.0019C57.9181 17.8106 53.2779 17.8155 49.5337 20.0146Z",
    fill: "#16806A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7325 25.654L30.723 36.5459C27.1291 38.7195 24.9331 42.6139 24.9331 46.8141V69.262C24.9331 73.4621 27.1291 77.3565 30.723 79.5301L48.7325 90.422C52.5427 92.7264 57.3157 92.7315 61.1308 90.4352L79.2547 79.5265C82.861 77.3559 85.0664 73.4544 85.0664 69.2452V46.8308C85.0664 42.6216 82.861 38.7202 79.2547 36.5495L61.1308 25.6409C57.3157 23.3446 52.5427 23.3496 48.7325 25.654Z",
    fill: "#6FCF97"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23305_180428",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 24,
    width: 31,
    height: 68
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.9331,
    y: 24.6343,
    width: 30.0667,
    height: 66.8079,
    fill: "#A7DDE0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23305_180428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7325 25.654L30.723 36.5459C27.1291 38.7195 24.9331 42.6139 24.9331 46.8141V69.262C24.9331 73.4621 27.1291 77.3565 30.723 79.5301L48.7325 90.422C52.5427 92.7264 57.3157 92.7315 61.1308 90.4352L79.2547 79.5265C82.861 77.3559 85.0664 73.4544 85.0664 69.2452V46.8308C85.0664 42.6216 82.861 38.7202 79.2547 36.5495L61.1308 25.6409C57.3157 23.3446 52.5427 23.3496 48.7325 25.654Z",
    fill: "#64BF8A"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3332 47L53.9998 65.3333L45.6665 57",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.054 2.76952C108.362 1.86729 109.638 1.86729 109.946 2.76952L112.378 9.88624C112.475 10.1715 112.696 10.3976 112.979 10.5016L119.946 13.0614C120.819 13.3823 120.819 14.6177 119.946 14.9386L112.979 17.4984C112.696 17.6024 112.475 17.8285 112.378 18.1138L109.946 25.2305C109.638 26.1327 108.362 26.1327 108.054 25.2305L105.622 18.1138C105.525 17.8285 105.304 17.6024 105.021 17.4984L98.0544 14.9386C97.181 14.6177 97.181 13.3823 98.0544 13.0614L105.021 10.5016C105.304 10.3976 105.525 10.1715 105.622 9.88624L108.054 2.76952Z",
    fill: "#FDB462"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.554 34.7737C101.862 33.871 103.138 33.871 103.446 34.7737L105.747 41.517C105.845 41.8023 106.065 42.0285 106.348 42.1326L112.95 44.5615C113.822 44.8827 113.822 46.1173 112.95 46.4385L106.348 48.8674C106.065 48.9715 105.845 49.1977 105.747 49.483L103.446 56.2263C103.138 57.129 101.862 57.129 101.554 56.2263L99.2527 49.483C99.1554 49.1977 98.9345 48.9715 98.6516 48.8674L92.0505 46.4385C91.1776 46.1173 91.1776 44.8827 92.0505 44.5615L98.6516 42.1326C98.9345 42.0285 99.1554 41.8023 99.2527 41.517L101.554 34.7737Z",
    fill: "#FDB462"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5506 13.8709C81.8531 12.9562 83.1469 12.9562 83.4494 13.8709L84.1819 16.0858C84.2765 16.3718 84.4949 16.5998 84.7764 16.7067L87.0374 17.5651C87.8975 17.8916 87.8975 19.1084 87.0374 19.4349L84.7764 20.2933C84.4949 20.4002 84.2765 20.6282 84.1819 20.9142L83.4494 23.1291C83.1469 24.0438 81.8531 24.0438 81.5506 23.1291L80.8181 20.9142C80.7235 20.6282 80.5051 20.4002 80.2236 20.2933L77.9626 19.4349C77.1025 19.1084 77.1025 17.8916 77.9626 17.5651L80.2236 16.7067C80.5051 16.5998 80.7235 16.3718 80.8181 16.0858L81.5506 13.8709Z",
    fill: "#FDB462"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_23305_180428",
    x: 0.5,
    y: 3.38232,
    width: 109,
    height: 118.235,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_23305_180428"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.266667 0 0 0 0 0.168627 0 0 0 0 0.54902 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23305_180428"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_23305_180428",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalSuccess);
export default __webpack_public_path__ + "static/media/medal-success.34299f7b7339c7669575e1f130106a94.svg";
export { ForwardRef as ReactComponent };